import { formatInTimeZone } from 'date-fns-tz';

const US_DATE_FORMAT = 'MM/dd/yyyy';

export const getDisplayDate = (date: Nullable<string>, format = US_DATE_FORMAT) => {
  if (!date) return null;
  return formatInTimeZone(new Date(date), 'UTC', format);
};
